import { CurrentUserData } from '#/graphql/types';
import { createContext } from 'react';

export interface SelectModeContextType extends Omit<Partial<CurrentUserData>, '__typename'> {
  selectModeOn: boolean;
}

const SelectModeContext = createContext<SelectModeContextType>({
  selectModeOn: false,
});

export default SelectModeContext;
